export default __webpack_public_path__ + "static/media/lourd-logo.a686c7d4.png";